'use strict';

const ajax = require('superagent');
const events = require('dom-events');
const Cookies = require('js-cookie');

const _ = require('../vendor/lodash/custom');

const msg = require('../messages.js');
const utils = require('../utils.js');

const Form = require('./form.js');

function AweberForm (ref) {
  Form.apply(this, Array.prototype.slice.call(arguments));

  var refs = {
    close: '[data-ref="form-close-' + ref + '"]',

    emailField: '[data-ref="field-input-email-' + ref + '"]',
    emailInput: '[data-ref="input-email-' + ref + '"]',
    emailNotification: '[data-ref="notification-email-' + ref + '"]',
  };
  _.assign(this.refs, refs);

  this.cookieName = 'rkb_aweber_form_' + ref;
}

AweberForm.prototype = new Form();

AweberForm.prototype.clearFields = function () {
  var email = document.querySelector(this.refs.emailInput);
  email.value = '';
};

AweberForm.prototype.successConsent = function (response) {
  var form = document.querySelector(this.refs.form);
  form.submit();
};

AweberForm.prototype.errorConsent = function (error) {
  var response = error.response;

  this.enableSubmit(msg.subscribeMe);

  var message = msg.unexpected;
  if (response && response.body.code === 'InvalidDataItemContent') {
    message = msg.invalidEmail;
  }
  this.showFormNotification(message);
};

AweberForm.prototype.onChange = function (event) {
  var email = utils.findTarget(this.refs.emailInput, event);
  if (email) {
    if (email.validity.valid) {
      this.setValidField(this.refs.emailField);
    } else {
      this.setInvalidField(this.refs.emailField, this.refs.emailInput);
    }
  }
};

AweberForm.prototype.onSubmit = function (event) {
  var form = utils.findTarget(this.refs.form, event);
  if (form) {
    event.preventDefault();

    var email = document.querySelector(this.refs.emailInput);
    if (!email.validity.valid) {
      this.setInvalidField(this.refs.emailField, this.refs.emailInput);
      return;
    }

    this.disableSubmit(msg.subscribing);

    var serializer = new XMLSerializer();
    var consent = {
      email: email.value,
      data: {
        email: email.value
      },
      form: serializer.serializeToString(form),
      privacyPolicy: 'https://staging.rukbottoland.com/politica-de-privacidad/',
      source: location.href
    };

    this.sendConsent(consent);
  }
};

AweberForm.prototype.onClick = function (event) {
  var close = utils.findTarget(this.refs.close, event);
  if (close) {
    event.preventDefault();
    var form = document.querySelector(this.refs.form);
    if (!form.className.includes(this.cls.formHidden)) {
      form.className = form.className.concat(' ' + this.cls.formHidden);
      Cookies.set(this.cookieName, '1', { expires: 7 });
    }
  }
};

AweberForm.prototype.bindEvents = function () {
  Form.prototype.bindEvents.call(this);

  this.onClick = this.onClick.bind(this);
  events.on(document, 'click', this.onClick);
};

module.exports = AweberForm;



//////////////////
// WEBPACK FOOTER
// ./_js/forms/aweber.js
// module id = 29
// module chunks = 0